const defaultColDef = {
    sortable: true,
    resizable: true,
    cellStyle: { lineHeight: '20px' },
};
const gridOptions = {
    defaultColDef,
    columnDefs: [],
    enableRangeSelection: true,
    floatingFilter: true,
    animateRows: true,
    allowContextMenuWithControlKey: true,
    headerHeight: 35,
};
export { gridOptions };
